import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AuthenticationService } from '../../security/authentication-service';
import { MenuItem, SubmenuItem } from 'app/core/model/menu-item';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('menuAnimation', [
      state('open', style({ height: '*', width: '14rem' })),
      state('closed', style({ height: '*', width: '2.5rem' })),
      transition('open <=> closed', animate('0.3s ease-in-out')),
    ]),
  ],
})

export class MenuComponent implements OnInit {
  menuOpen = false;

  menuLista: MenuItem[] = [
    { ordem: 1, titulo: 'Relatórios', link: '/obrigacoes-acessorias', icone: 'bi bi-file-earmark-ruled', role: '', perfil: '', externo: false },
    { ordem: 3, titulo: 'Extrato Processamento EFD', link: '/extrato-processamento-efd', icone: 'journal-check', role: '', perfil: '', externo: false,
      submenus: [
        { titulo: 'Consultar Extrato', link: '/extrato-processamento-efd' },
        { titulo: 'Validar Extrato', link: '/validar-extrato' },
      ],
    },
  ];

  constructor(
    public authService: AuthenticationService
  ) {
  }

  ngOnInit(): void {
    this.menuLista.sort((a, b) => a.ordem - b.ordem);
  }

  temPermissaoParaExibir(role: string): boolean {
    if (!role || role.trim() === '') {
      return true; // Se não houver role especificada, exibe o item
    }
    return AuthenticationService.temPermissaoParaExibirItemMenu(role);
  }

  abrirLinkExterno(url: string): void {
    window.open(url, '_self');
  }

  montarSubmenus(submenus?: SubmenuItem[], externoPadrao = false): string | null {
    if (!submenus || submenus.length === 0) {
      return null;
    }

    return JSON.stringify(
      submenus.map(submenu => ({
        title: submenu.titulo,
        href: this.montarLink(submenu.link, submenu.externo ?? externoPadrao),
      }))
    );
  }

  obterSubmenus(submenus?: SubmenuItem[], externoPadrao = false): { title: string; href: string }[] {
    if (!submenus || submenus.length === 0) {
      return [];
    }
    return submenus.map(submenu => ({
      title: submenu.titulo,
      href: this.montarLink(submenu.link, submenu.externo ?? externoPadrao),
    }));
  }

  montarLink(link: string, externo = false): string {
    const linkNormalizado = link.replace(/^\/+|\/?#$/, '');
    return externo ? `${linkNormalizado}/#` : `#/${linkNormalizado}`;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  logout(): void {
    this.authService.logout();
  }
}
